// extracted by mini-css-extract-plugin
export default {"checkIcon":"PricingCheckIcon-module__checkIcon--tpYNI"};